export default function roundCurrency(number: number, currency: string) {
  let result;
  switch (currency) {
    case "CZK":
      result = Math.round(number);
      break;

    default:
      result = number;
      break;
  }
  return result;
}
